export const downloadPrnFile = ({ items = [], prnCode = "", fileName }) => {
  if (!Array.isArray(items) || !items.length) return;

  const blob = new Blob([prnCode], { type: "text/plain" });
  const url = URL.createObjectURL(blob);

  let finalName = fileName || "labels.prn";

  if (!fileName) {
    if (items.length === 1) {
      finalName = `${items[0]?.itemCode || items[0]?.ItemCode || "label"}.prn`;
    } else {
      const firstCode =
        items[0]?.itemCode || items[0]?.ItemCode || "first-item";
      const lastCode =
        items[items.length - 1]?.itemCode ||
        items[items.length - 1]?.ItemCode ||
        "last-item";
      finalName = `${firstCode}_${lastCode}.prn`;
    }
  }

  const a = document.createElement("a");
  a.href = url;
  a.download = finalName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};